import React, { Component } from 'react';
import * as Styles from './Styles';
import { JSXLike } from '../../models/Global';
import { v4 as uuid } from 'uuid';

interface Content {
	pageTitle: string;
	pageContent: JSXLike;
}

interface ContentFull extends Content {
	id: string;
}

type Props = {
	content: Content[];
	style?: React.CSSProperties;
};

type State = {
	selectedId: string | null;
	mapped: ContentFull[];
};

class PaginatedDescription extends Component<Props, State> {
	state: State = {
		selectedId: null,
		mapped: [],
	};

	componentDidMount(): void {
		const mapped: ContentFull[] = this.props.content.map((el) => ({
			...el,
			id: uuid(),
		}));

		const active = mapped[0];

		this.setState({
			...this.state,
			mapped,
			selectedId: active ? active.id : null,
		});
	}

	render() {
		const currentContent = this.state.mapped.find(
			(el) => el.id === this.state.selectedId
		)?.pageContent;

		return (
			<Styles.Wrapper style={this.props.style}>
				<Styles.PagesContainer>
					{this.state.mapped.map((el) => (
						<Styles.PageButton
							current={el.id === this.state.selectedId}
							key={el.id}
							onClick={() =>
								this.setState({
									...this.state,
									selectedId: el.id,
								})
							}
						>
							{el.pageTitle}
						</Styles.PageButton>
					))}
				</Styles.PagesContainer>
				<Styles.ContentContainer>
					{currentContent}
				</Styles.ContentContainer>
			</Styles.Wrapper>
		);
	}
}

export default PaginatedDescription;
